module.exports = __webpack_public_path__ + "static/media/preview_earning_campaigns_7.ec427302.svg";